// extracted by mini-css-extract-plugin
export default {"page":"I1-z","cartModal":"J1-z","checkout":"K1-z","placeholder":"L1-z","account":"M1-z"};